import type { ReactNode } from 'react';
import { cn } from '@rocco/utils/cn';

interface PolicyPageLayoutProps {
    /** Shared legal-policy page title rendered above the page content. */
    title: string;
    children: ReactNode;
    className?: string;
    titlePrefix?: ReactNode;
    titleClassName?: string;
}

/**
 * Shared Tailwind layout for legal and policy pages that need to match the
 * legacy privacy-policy page shell.
 */
const PolicyPageLayout = ({
    title,
    children,
    className,
    titlePrefix,
    titleClassName,
}: PolicyPageLayoutProps) => {
    return (
        <main className="h-full bg-[#ededed] pt-[4.625rem] md:pt-0">
            <div
                className={cn(
                    'flex h-full justify-center px-[40px] py-[60px] md:pt-[80px]',
                    className,
                )}
            >
                <div className="w-full max-w-[87.5rem]">
                    {titlePrefix}
                    <h1
                        className={cn(
                            'mb-[40px] w-full text-center text-[2.25rem] leading-[1.2] font-semibold text-gray-900 antialiased md:text-[3.5rem]',
                            titleClassName,
                        )}
                    >
                        {title}
                    </h1>
                    {children}
                </div>
            </div>
        </main>
    );
};

export default PolicyPageLayout;
